/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import DailyClosingDetail from './DailyClosingDetail'
import DailyClosingHead from './DailyClosingHead'
import Reservation from './Reservation'

/**
 * The InlineResponse204 model module.
 * @module model/InlineResponse204
 * @version 1.0.0
 */
export default class InlineResponse204 {
  /**
   * Constructs a new <code>InlineResponse204</code>.
   * @alias module:model/InlineResponse204
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse204</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse204} obj Optional instance to populate.
   * @return {module:model/InlineResponse204} The populated <code>InlineResponse204</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse204()

      if (data.hasOwnProperty('daily_closing_head')) {
        obj['daily_closing_head'] = DailyClosingHead.constructFromObject(data['daily_closing_head'])
      }
      if (data.hasOwnProperty('daily_closing_details')) {
        obj['daily_closing_details'] = ApiClient.convertToType(data['daily_closing_details'], [DailyClosingDetail])
      }
      if (data.hasOwnProperty('reservations')) {
        obj['reservations'] = ApiClient.convertToType(data['reservations'], [Reservation])
      }
    }
    return obj
  }

  /**
   * @member {module:model/DailyClosingHead} daily_closing_head
   */
  daily_closing_head = undefined
  /**
   * @member {Array.<module:model/DailyClosingDetail>} daily_closing_details
   */
  daily_closing_details = undefined
  /**
   * @member {Array.<module:model/Reservation>} reservations
   */
  reservations = undefined
}
